import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';
import { useFetch } from "../../../context/fetch";
import { HistoryLogI } from "../../../redux/approvals/approvalsTypes";

const APPROVALS_LOGS_ENDPOINT = "approvals/history/logs";

const approvalsKeys = {
  all   : [ "approvals_logs" ] as const,
  lists : () => [ ...approvalsKeys.all, "list" ] as const,
  list  : (filters?: UseApprovalsFilters) => [ ...approvalsKeys.lists(), filters ] as const,
};

type ApprovalsPageAttr = {
  data: Array<HistoryLogI>;
  pagination: {
    count: number;
    limit: number;
    page: number;
  };
}

type UseApprovalsFilters = Partial<{
  status: string;
  equipment_type: string;
  carrier: string | null;
  destination: string;
  origin: string;
  pick_up_date: string;
  drop_off_date: string;
  limit: number;
  page: number;
}>

const useApprovalsLogs = (
  filters: UseApprovalsFilters,
  config?: UseQueryOptions<ApprovalsPageAttr>,
): UseQueryResult<ApprovalsPageAttr> => {
  const { authRequest } = useFetch();

  return useQuery<ApprovalsPageAttr>(
    approvalsKeys.list(filters),
    async () => (await authRequest.get<ApprovalsPageAttr>(APPROVALS_LOGS_ENDPOINT, { params: filters })).data,
    config,
  );
};

export { approvalsKeys, useApprovalsLogs };
